<template>
  <div class="home-about-item ad">
    <div class="home-item-left">
      <placed-image url="img/it-moves.jpg" />
    </div>
    <div class="home-item-right">
      <div class="brown-head">
        <editable-item :page="pagename" item="animated-by-bhead" :loaded="storiesLoaded" />
      </div>
      <editable-item :page="pagename" item="animated-by-ad" :loaded="storiesLoaded" />
      <div class="b-panel">
        <ix-router-link class="redlink" to="/animated">www.illustrationx.com/animated</ix-router-link>
      </div>
    </div>
  </div>
</template>

<script>
import PlacedImage from '@/components/widgets/PlacedImage.vue'
import EditableItem from '@/components/editors/EditableItem.vue'
import ViewablePanel from '@/mixins/ViewablePanel.js'

import '@/css/home-about-item.css'

export default {
  mixins: [ViewablePanel ],
  components: {
    PlacedImage,
    EditableItem
  },
  data () {
    return {
      storiesLoaded: false,
      pagename: 'home-anim'
    }
    
  },
  methods: {
    async init () {
      this.$k.fetchStories(this.pagename, () => {
        this.storiesLoaded = true
      })
    }
  },
  watch: {
    seen () {
      this.init()
    }
  }
}
</script>

<style>

</style>